import * as THREE from 'three'

export let createDraggableCargoPlaceholder = () => {
  let placeholder = new THREE.Object3D()
  placeholder.name = '__placeholder__'
  placeholder.userData.isPlaceholder = true
  return placeholder
}

export function isPlaceholder(object) {
  return object?.userData?.isPlaceholder === true
}

export function startTime() {
  console.log('🔵 startTime function CALLED');
  return new Date();
}

export function endTime(
  event,
  end_time, // Changed parameter name to avoid conflict
  timeDiff,
  start_time,
  controls,
  cargo_group,
  clickMouse,
  canvasBounds,
  raycaster,
  camera,
  scene,
  draggable_cargo,
  backup_draggable_cargo,
  cargos,
  setCargos
) {
  console.log('🔵 endTime function CALLED');
  
  // Use the parameters passed from the component
  console.log('🔵 Time diff:', timeDiff, 'ms');
  
  if (timeDiff < 200) {
    console.log('🔵 Quick click - picking object');
    catch_draggable(
      controls,
      cargo_group,
      clickMouse,
      canvasBounds,
      raycaster,
      camera,
      scene,
      draggable_cargo,
      backup_draggable_cargo,
      cargos,
      setCargos
    )
  } 
}


// Realtime catching object after mouse clicking on canvas
export function catch_draggable(  // ADD EXPORT HERE
  controls,
  cargo_group,
  clickMouse,
  canvasBounds,
  raycaster,
  camera,
  scene,
  draggable_cargo,
  backup_draggable_cargo,
  cargos,
  setCargos
) {
console.log('🟣 catch_draggable received cargos:', cargos);
console.log('🟣 cargos length in function:', cargos.length);
  
  if (!isPlaceholder(draggable_cargo.current)) {
    controls.enabled = false
    if (
      check_collision_of_draggable_cargo_and_other_cargos(
        draggable_cargo,
        backup_draggable_cargo,
        cargo_group,
        cargos,
        setCargos
      )
    ) {
      console.log('Before refreshCargosInReact - current cargos:', cargos);      
      refreshCargosInReact(draggable_cargo, cargos, setCargos)
    }

    draggable_cargo.current.material.opacity = 1
    draggable_cargo.current.material.transparent = false
    draggable_cargo.current.children[0].material.color.set('black')

    draggable_cargo.current.removeFromParent()
    cargo_group.add(draggable_cargo.current)

    draggable_cargo.current = createDraggableCargoPlaceholder()
    backup_draggable_cargo.current = createDraggableCargoPlaceholder()

    if (isPlaceholder(draggable_cargo.current)) {
      controls.enabled = true
      return
    }
  }

  clickMouse.x =
    ((event.clientX - canvasBounds.left) /
      (canvasBounds.right - canvasBounds.left)) *
      2 -
    1
  clickMouse.y =
    -(
      (event.clientY - canvasBounds.top) /
      (canvasBounds.bottom - canvasBounds.top)
    ) *
      2 +
    1

  raycaster.setFromCamera(clickMouse, camera)

  if (
    event.clientX > canvasBounds.left &&
    event.clientX < canvasBounds.right &&
    event.clientY < canvasBounds.bottom &&
    event.clientY > canvasBounds.top
  ) {
    let found = raycaster.intersectObjects(cargo_group.children, false)

    if (found.length > 0 && found[0].object.userData.isFloor == false) {
      draggable_cargo.current = found[0].object
      backup_draggable_cargo.current = found[0].object.clone()

      draggable_cargo.current.userData.intersecteble = false
      draggable_cargo.current.userData.isPlaceholder = false

      draggable_cargo.current.removeFromParent()

      draggable_cargo.current.material.opacity = 0.2
      draggable_cargo.current.material.transparent = true
      draggable_cargo.current.children[0].material.color.set('GREEN')

      scene.add(draggable_cargo.current)
    }
  }
}

// dragObjectsFunctions.js
export const readMouseMove = (event, renderer, moveMouse) => {
  // Add null checks
  if (!renderer || !renderer.domElement || !moveMouse) {
    console.warn('readMouseMove called with invalid parameters')
    return
  }
  
  const canvas = renderer.domElement
  const rect = canvas.getBoundingClientRect()
  
  // Calculate mouse position in normalized device coordinates
  moveMouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1
  moveMouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1
}

//Create function for check collision after user dragging cargo
export function check_collision_of_draggable_cargo_and_other_cargos(
  draggable_cargo,
  backup_draggable_cargo,
  cargo_group,
  cargos,
  setCargos
) {
  console.log('🟡 Checking collision for:', draggable_cargo.current.uuid);
  
  const box1 = new THREE.Box3().setFromObject(draggable_cargo.current);
  box1.min.x = box1.min.x + 0.01;
  box1.min.y = box1.min.y + 0.01;
  box1.min.z = box1.min.z + 0.01;

  box1.max.x = box1.max.x - 0.01;
  box1.max.y = box1.max.y - 0.01;
  box1.max.z = box1.max.z - 0.01;

  let hasCollision = false;

  if (cargo_group.children.length > 0) {
    for (let i = 0; i < cargo_group.children.length; i++) {
      if (cargo_group.children[i].uuid === draggable_cargo.current.uuid) {
        continue;
      }

      let box2 = new THREE.Box3().setFromObject(cargo_group.children[i]);
      if (box1.intersectsBox(box2)) {
        console.log('🟡 Collision detected with:', cargo_group.children[i].uuid);
        draggable_cargo.current.position.x = backup_draggable_cargo.current.position.x;
        draggable_cargo.current.position.y = backup_draggable_cargo.current.position.y;
        draggable_cargo.current.position.z = backup_draggable_cargo.current.position.z;
        hasCollision = true;
        break;
      }
    }
  }
  
  console.log('🟡 Collision result:', hasCollision);
  return !hasCollision;
}

// In dragObjectsFunctions.js - fix the refreshCargosInReact function
// In dragObjectsFunctions.js - FIXED VERSION
function refreshCargosInReact(draggable_cargo, cargos, setCargos) {
  console.log('🟠 refreshCargosInReact called');
  console.log('🟠 Current draggable cargo:', draggable_cargo.current);
  
  if (isPlaceholder(draggable_cargo.current)) {
    console.log('🟠 Skipping - object is placeholder');
    return;
  }

  let uuid = draggable_cargo.current.uuid;
  
  // Calculate the new position (bottom-left corner)
  let x = draggable_cargo.current.position.x - draggable_cargo.current.geometry.parameters.width / 2;
  let y = draggable_cargo.current.position.y - draggable_cargo.current.geometry.parameters.height / 2;
  let z = draggable_cargo.current.position.z - draggable_cargo.current.geometry.parameters.depth / 2;
  
  let xPos = Math.round(x);
  let yPos = Math.round(y);
  let zPos = Math.round(z);
  
  console.log(`🟠 Updating cargo ${uuid} to position: (${xPos}, ${yPos}, ${zPos})`);
  
  // USE FUNCTIONAL UPDATE - this ensures we get the latest state
  setCargos(prevCargos => {
    console.log('🟠 Previous cargos in setCargos:', prevCargos);
    
    const newCargos = prevCargos.map((cargo) => {
      if (cargo.uuid === uuid) {
        console.log('🟠 Found matching cargo to update');
        return { 
          ...cargo, 
          x: xPos, 
          y: yPos, 
          z: zPos 
        };
      }
      return cargo;
    });

    console.log('🟠 New cargos after update:', newCargos);
    return newCargos;
  });
}